import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";

const withAnimation = (WrappedComponent: React.ComponentType<any>) => {
  return (props: any) => {
    const componentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (componentRef.current) {
        gsap.fromTo(
          componentRef.current,
          { opacity: 0, y: 50 },
          { opacity: 1, y: 0, duration: 0.5 }
        );
      }

      return () => {
        if (componentRef.current) {
          gsap.to(componentRef.current, {
            opacity: 0,
            y: -50,
            duration: 0.5,
            onComplete: () => {
              if (props.onAnimationComplete) {
                props.onAnimationComplete();
              }
            },
          });
        }
      };
    }, []);

    return (
      <div ref={componentRef}>
        <WrappedComponent {...props} />
      </div>
    );
  };
};

export default withAnimation;
